module.exports = __webpack_public_path__ + "7e70073457bd8051b1240bbe838de71c.pdf";